import { apiPostWToken } from "../../api/apiPost";
import { ConfAccount } from "../../context/account/paramsAccount";

export function saveHl(
    url: string,
    data: object,
    token: string | null,
    conf: ConfAccount,
    setConf: React.Dispatch<React.SetStateAction<ConfAccount>>,
    showError: any
) {
    return new Promise<any>((resolve, reject) => {
        if (conf.conf.ifOffLineMode !== true || conf.conf.ifOffLineMode === undefined) {
            apiPostWToken(url, data, token, conf, setConf, showError)
                .then((response: any) => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        }
        else {
        }
    });
}

